export default {
  fa1867274c620cab693b19300a45ddaa: '商品信息曝光',
  '3e89518163a3351ffe9c3b45eb79c1e7': '购买了此商品',
  '05ab0a36affc1175c16fab9076748722': '商品详情页_SKU选择抽屉',
  '4996955f4fc9a910a791be31c7a0472a': '商品详情页_SKU选择抽屉_确定按钮',
  '92de5d8d5ec05a369b92feb778ac1ad6': '商品详情页_SKU选择抽屉_选择订阅模式',
  '9534aec7cb47306b9d4b998bb93552a0': '营销商城',
  '1f6b456ffcd1373bf6051e0294229dc4': '该商品暂时无法购买，请联系客服',
  '952b517752a3d54632a5640bd983e3db': '领券失败，请稍后再试',
  '94cf66d520636599442ae580f655732e': '原价',
  a3e40f84213811f2a5420230554d3dc5: '已下架',
  c966a45e7226d9eee149a7d5f542be9f: '登录查看优惠',
  '29a0c08714a4c60d760cd5bf677ebc57': '暂无预约资格',
  fc4cb54ebbbc715d113476129bb4c0b8: '预约未开始',
  df87923079d7c0beb2c4559579a85862: '将于',
  ab9e4d1819317951394a1316fcf79a76: '开始预约',
  '88d0e2a03b050f0e0a8b13fec60ffe78': '开售',
  '3b0d4aa3dda61c76b8217fb7b8a78966': '即将开售',
  f1a8ca0bf5adda5ba15f7ddad58c2346: '预约成功',
  '1d2d66fef8bf1d9bc256e789a97c566d': '预约失败',
  '0ec92c3187b7485cf5ec346e5c1ccd75': '立即预约',
  '1f3807f10bd3a5cd55a044733c9c0996': '已有',
  '261622ea4a29c8f12e789b844fc405b1': '人预约成功',
  '416fefbd19825f08b791241e7edd6a51': '商品详情页_预约活动',
  '3fb081aab838be9abd808e7a19a45c56': '立即购买',
  '162396af34628a10c00e1b1644110716': '商品为限购商品，您不满足限购条件，无法购买',
  '669641b519d1f9bf11ded3320a76f079': '仅剩',
  c64a99d7afe2453355628b9b0dff433e: '天',
  '4c848c2101c0737bf8f0fb1e54e04130': '已抢完',
  e1e95652c564a2883bff1f99121934d8: '未开始',
  '86e47c5015f810ab093752bccbc4b791': '已结束',
  e812cd2beffffe788e963984841d39d0: '已抢光',
  f1e03e04de7143d17e58d507dcc16e1a: '已抢',
  '0283ca891df8ff2d91fad9917d24c699': '剩余',
  '992f734b9ab6402aabe9863b1cf9d58d': '商品详情页_购买按钮',
  '9a4d0400ff2d75d257318a86200a884a': '立即抢购',
  '26a625c871b5730a5028ee65d0ebbd18': '暂无资格前往获取',
  '24b7cd62ef456f2c6f81908615a85c1c': '暂无兑换资格',
  e52ccbf0173ff6095d2b955c58bb6b85: '已售罄',
  df10c47ea53f3644cb9b3995c8def019: '单独购买',
  '2abe7f76b1ef67ef9d1a3bbe2afe0a1f': '发起团购',
  ce545df1de3e9f821aa842fb8f580ce8: '成长豆不足立即获取',
  '508db4afefb61cd38af412b31874d4ea': '成长豆余额不足',
  b75075febe9e4b01de53c0e39e243cc4: '购物车按钮',
  '1a47a6da484d3058d0974301171a0370': '商品详情页',
  ffaf8d4f12b89ab2c9866ccf84583b14: '购物车',
  c79163cb21cc27322b50bb6e22090275: '加入购物车',
  '168d94052e4771724dca6bf540390822': '选择商品',
  '47688c2ad210c848d5368bc8917935af': '限时抢购',
  '4add70c59aaa6fff4f563d7b0abb9806': '免费领取',
  '118083967c1501a3ba4ed8f90f48f579': '立即兑换',
  '66c4341dd5a6ce1ac4abb0346c078042': '距开售仅剩',
  '9e178372463647f75cea572b82ec5034': '{day}天 {hour}:{minute}:{second}',
  ef8e7256d8e3cc00087df4b450c4c0b4: 'MM月DD日HH:mm',
  e9695eac45fefc77f14677ddc3639210: '结束',
  bbb9cf1247041e89c64d0b04b0264cc5: '加入购物车成功',
  '895f1ed7be4a2dff52b3ec47edc3de8a': '加入购物车失败',
  '1c32ef03d1544e96db89fedc7afa1114': '已减',
  e64983c2cf4b6d4461e4c404bdc066be: '请选择商品',
  '4b408e8c9aff77497db39c805e591284': '领券购买',
  '4e1c895fd1d75219af8bf261ac3fbf02': '确定',
  ac0b38c4e4a83be646db377c09d38e76: '参数错误!',
  '281cc99bc680ecf1a58bed226a39951b': '点击播放视频',
  '223b5a41656ee568204b0c862266a5c3': '分享',
  d045167754a45367b1884ad0acfbbd90: '配送',
  a855b1dba6164b6c42d62bec1e575cb5: '快递配送',
  '91e48cde1965d26b4388fad2e07ffd3e': '说明',
  '6f576b416c5f5471bedae323ba304c71': '商品详情页_客服按钮',
  fb5bbf467b0d4d15adf84492055bbba7: '客服',
  c1fea370ae50c6fbc27e520df63e0dd2: '适用于',
  c1a324ab0a445f9b5fcfe71c9eec0133: '商品详情页_SKU选择抽屉_选择商品',
  '0fc3286efd4cafb5a59ed10930a07a6b': '购买数量',
  ec1639bb0872bc4e2b7da0c93c1974e6: '前往查看',
  '887c3e401e47568d2322008ccac1dd58': '您已参加拼团活动,点击下方按钮查看拼团进度哦',
  a3eceb8e20af5c8a867d2ca0380f3458: '商品详情页_挽留 弹窗曝光',
  '6b908a8532c15fb1d35be87e33894c87': '商城',
  d317e2c21b292b6d885ad97e0279592d: '商品详情页_挽留弹窗内容按钮点击',
  '07f53e3f4a29c2469498c84d8084415f': '其他',
  bd48cd45b8b0cf763d9d1e752459921b: '商品详情页_挽留弹窗底部按钮点击'
};
